import { render } from "./PaymentTypesManagement.vue?vue&type=template&id=2ffab17a&scoped=true"
import script from "./PaymentTypesManagement.vue?vue&type=script&lang=js"
export * from "./PaymentTypesManagement.vue?vue&type=script&lang=js"

import "./PaymentTypesManagement.vue?vue&type=style&index=0&id=2ffab17a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ffab17a"]])

export default __exports__